import { Button } from '@fluentui/react-components';
import { isRouteErrorResponse, useRouteError } from 'react-router';
import { StatusScreen } from '#src/shared/StatusScreen';

/**
 * Erro ao carregar ou renderizar uma rota. Sem isto, o React Router mostra a
 * própria tela de erro, em inglês e sem o tema.
 */
export function RouteError() {
  const error = useRouteError();
  const description = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : undefined;

  return (
    <StatusScreen
      fullPage
      tone="error"
      title="Algo deu errado nesta página"
      {...(description === undefined ? {} : { description })}
      action={
        <Button appearance="primary" onClick={() => window.location.reload()}>
          Recarregar
        </Button>
      }
    />
  );
}
